import { TICK_TIME } from "../../utils/constants";
import UI from "../UI";

class BranchesEnergyBars {
  constructor(scene) {
    this.scene = scene;
    this.branch1 = {
      progressBox: null,
      progressBar: null,
      value: 0,
      x: 0,
      y: 0,
      barWidth: 0,
      barHeight: 0,
      flash: null,
    };
    this.branch2 = {
      progressBox: null,
      progressBar: null,
      value: 0,
      x: 0,
      y: 0,
      barWidth: 0,
      barHeight: 0,
      flash: null,
    };
    this.branch3 = {
      progressBox: null,
      progressBar: null,
      value: 0,
      x: 0,
      y: 0,
      barWidth: 0,
      barHeight: 0,
      flash: null,
    };
  }

  draw({ x, y }) {
    const BAR_WIDTH = UI.tileToScreen(0.3);
    const BAR_HEIGHT = UI.tileToScreen(1);
    const GUTTER = UI.tileToScreen(0.03);
    const PADDING = UI.pixelToScreen(1);
    this.branch1.progressBox = this.scene.add.graphics();
    this.branch1.progressBox.name = "progressBox1"
    this.branch1.progressBox.depth = 100;
    this.branch1.progressBox.setScrollFactor(0);
    this.branch1.progressBox.fillStyle(0x486859, 0.8);
    this.branch1.progressBox.fillRect(x, y, BAR_WIDTH, BAR_HEIGHT);

    this.branch1.progressBar = this.scene.add.graphics();
    this.branch1.progressBar.name = "progressBar1"

    this.branch1.progressBar.depth = 101;
    this.branch1.progressBar.setScrollFactor(0);
    this.branch1.progressBar.fillStyle(0x5d9b79, 1);
    this.branch1.barWidth = BAR_WIDTH - 2 * PADDING;
    this.branch1.barHeight = BAR_HEIGHT - 2 * PADDING;
    this.branch1.x = x + PADDING;
    this.branch1.y = y + PADDING + this.branch1.barHeight;
    this.branch1.progressBar.fillRect(
      this.branch1.x,
      this.branch1.y,
      this.branch1.barWidth,
      - this.branch1.barHeight
    );
    
    this.branch1.flash = this.scene.plugins
      .get("rexFlash")
      .add(this.branch1.progressBar, { duration: TICK_TIME, repeat: 2 });

    this.branch2.progressBox = this.scene.add.graphics();
    this.branch2.progressBox.name = "progressBox2"
    this.branch2.progressBox.depth = 100;
    this.branch2.progressBox.setScrollFactor(0);
    this.branch2.progressBox.fillStyle(0x486859, 0.8);
    this.branch2.progressBox.fillRect(
      x + BAR_WIDTH + GUTTER,
      y,
      BAR_WIDTH,
      BAR_HEIGHT
    );

    this.branch2.progressBar = this.scene.add.graphics();
    this.branch2.progressBar.name = "progressBar2"
    this.branch2.progressBar.depth = 101;
    this.branch2.progressBar.setScrollFactor(0);
    this.branch2.progressBar.fillStyle(0x5d9b79, 1);
    this.branch2.barWidth = BAR_WIDTH - 2 * PADDING;
    this.branch2.barHeight = BAR_HEIGHT - 2 * PADDING;
    this.branch2.x = x + BAR_WIDTH + GUTTER + PADDING;
    this.branch2.y = y + PADDING + this.branch1.barHeight;
    this.branch2.progressBar.fillRect(
      this.branch2.x,
      this.branch2.y,
      this.branch2.barWidth,
      - this.branch2.barHeight
    );
    this.branch2.flash = this.scene.plugins
      .get("rexFlash")
      .add(this.branch2.progressBar, { duration: TICK_TIME, repeat: 2 });

    this.branch3.progressBox = this.scene.add.graphics();
    this.branch3.progressBox.name = "progressBox3"
    this.branch3.progressBox.depth = 100;
    this.branch3.progressBox.setScrollFactor(0);
    this.branch3.progressBox.fillStyle(0x486859, 0.8);
    this.branch3.progressBox.fillRect(
      x + 2 * BAR_WIDTH + 2 * GUTTER,
      y,
      BAR_WIDTH,
      BAR_HEIGHT
    );

    this.branch3.progressBar = this.scene.add.graphics();
    this.branch3.progressBar.name = "progressBar3"
    this.branch3.progressBar.depth = 101;
    this.branch3.progressBar.setScrollFactor(0);
    this.branch3.progressBar.fillStyle(0x5d9b79, 1);
    this.branch3.barWidth = BAR_WIDTH - 2 * PADDING;
    this.branch3.barHeight = BAR_HEIGHT - 2 * PADDING;
    this.branch3.x = x + 2 * BAR_WIDTH + 2 * GUTTER + PADDING;
    this.branch3.y = y + PADDING + this.branch1.barHeight;
    this.branch3.progressBar.fillRect(
      this.branch3.x,
      this.branch3.y,
      this.branch3.barWidth,
      - this.branch3.barHeight
    );
    this.branch3.flash = this.scene.plugins
      .get("rexFlash")
      .add(this.branch3.progressBar, { duration: TICK_TIME, repeat: 2 });

    this.scene.events.on("branch_takes_damage", this.reduceValue.bind(this));
  }

  reduceValue({branchId, newValue}) {
    const branch = 
      branchId === "LEFT_BRANCH"
        ? this.branch1
        : branchId === "MID_BRANCH"
        ? this.branch2
        : this.branch3;

    branch.progressBar.clear();
    branch.progressBar.fillStyle(0x5d9b79, 1);
    branch.progressBar.fillRect(
      branch.x,
      branch.y,
      branch.barWidth,
      - newValue * branch.barHeight
    );
    console.log(branch.flash);
    if(branch.flash.timer) {
      branch.flash.flash()
    }
  }
}

export default BranchesEnergyBars;
